import { render, staticRenderFns } from "./NovoFaq.vue?vue&type=template&id=5637730b"
import script from "./NovoFaq.vue?vue&type=script&lang=ts"
export * from "./NovoFaq.vue?vue&type=script&lang=ts"
import style0 from "./NovoFaq.vue?vue&type=style&index=0&id=5637730b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports